import { _ as e } from "./index918.mjs";
var a = e, t = a(Object, "create"), v = t;
export {
  v as _
};
